import React from 'react';

const Logo = ({ size = 40 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      {/* Outer circle - EU blue */}
      <circle cx="50" cy="50" r="48" fill="#0f3b5e" stroke="#0a2d47" strokeWidth="2"/>
      
      {/* Inner white circle */}
      <circle cx="50" cy="50" r="38" fill="white"/>
      
      {/* EU stars (simplified) */}
      <g fill="#0f3b5e">
        <circle cx="50" cy="16" r="3.5"/>
        <circle cx="34" cy="20" r="3"/>
        <circle cx="23" cy="32" r="3"/>
        <circle cx="18" cy="50" r="3.5"/>
        <circle cx="23" cy="68" r="3"/>
        <circle cx="34" cy="80" r="3"/>
        <circle cx="50" cy="84" r="3.5"/>
        <circle cx="66" cy="80" r="3"/>
        <circle cx="77" cy="68" r="3"/>
        <circle cx="82" cy="50" r="3.5"/>
        <circle cx="77" cy="32" r="3"/>
        <circle cx="66" cy="20" r="3"/>
      </g>
      
      {/* "P" letter in center */}
      <text 
        x="50" 
        y="54" 
        textAnchor="middle" 
        fontFamily="Arial, sans-serif" 
        fontSize="28" 
        fontWeight="700" 
        fill="#0f3b5e"
        dominantBaseline="central"
      >P</text>
      
      {/* Connecting lines - supply chain theme */}
      <line x1="18" y1="50" x2="30" y2="50" stroke="#0f3b5e" strokeWidth="1.5" opacity="0.3"/>
      <line x1="70" y1="50" x2="82" y2="50" stroke="#0f3b5e" strokeWidth="1.5" opacity="0.3"/>
      <line x1="50" y1="18" x2="50" y2="30" stroke="#0f3b5e" strokeWidth="1.5" opacity="0.3"/>
      <line x1="50" y1="70" x2="50" y2="82" stroke="#0f3b5e" strokeWidth="1.5" opacity="0.3"/>
    </svg>
  );
};

export default Logo;